import { gsap } from 'gsap'

import Common from 'js/_core/Common'

import ViewController from 'js/app/controllers/ViewController'
import LottieAnimation from 'js/modules/_base/effects/lottie/LottieAnimation'
import CurrentTimeDisplay from 'js/modules/projects/effects/CurrentTimeDisplay'
import NavBusinessHighlighter from 'js/modules/projects/navigation/NavBusinessHighlighter'
import HomeFadeSlideshow from 'js/modules/projects/ui/HomeFadeSlideshow'

import SlotAnimation from 'js/modules/projects/effects/SlotAnimation'
import HomeFirstScrollProgressAnimation from 'js/modules/projects/effects/HomeFirstScrollProgressAnimation'
import HomeCareerCopyScrollProgressAnimation from 'js/modules/projects/effects/HomeCareerCopyScrollProgressAnimation'

export default class HomeViewController extends ViewController {
  constructor(content) {
    super(content)
    if (this.debug) {
      this.pageName = '[Home]'
    }

    // ページ別のコンテンツ(html)はここからアクセスできます
    this.$content = content
    this.currentTimeDisplay = new CurrentTimeDisplay({
      $contentRoot: this.$content,
    })
    this.navBusinessHighlighter = new NavBusinessHighlighter({
      $contentRoot: this.$content,
    })

    this.isInViwAnimationSceneBusiness = false

    this.fadeSlideshowInstances = []

    if (!Common.detection.useWebgl) {
      this.$slideshowWraps.forEach(($slideshowWrap, i) => {
        this.fadeSlideshowInstances[i] = new HomeFadeSlideshow({
          $wrapper: $slideshowWrap,
        })
        this.fadeSlideshowInstances[i].init()
        this.fadeSlideshowInstances[i].run()
      })
    }

    this.slotAnimation = new SlotAnimation({
      $contentRoot: this.$content,
    })

    if (!Common.detection.isMobileLayout && !Common.detection.isTabletDevice && !Common.detection.isMobileDevice) {
      this.homeFirstScrollProgressAnimation = new HomeFirstScrollProgressAnimation({
        $contentRoot: this.$content,
      })

      this.homeCareerCopyScrollProgressAnimation = new HomeCareerCopyScrollProgressAnimation({
        $contentRoot: this.$content,
      })
    }
    // }
  }

  async willLoad() {
    await super.willLoad()
  }

  async didLoad() {
    await super.didLoad()
  }

  async beforeEnter() {
    await super.beforeEnter()
    this._setAnimationScenes()
    this.currentTimeDisplay?.init()
  }

  async enter() {
    this.addHandlers()
    await super.enter()
    this._addObservers()
    this.navBusinessHighlighter?.init()
    this.slotAnimation?.init()
    this.homeFirstScrollProgressAnimation?.init()
    this.homeCareerCopyScrollProgressAnimation?.init()
    if (Common.webgl) {
      gsap.delayedCall(0.4, () => {
        Common.webgl.fvAnimation({
          pageId: 'Home',
        })
      })
    }
  }

  async afterEnter() {
    await super.afterEnter()
  }

  async beforeLeave() {
    await super.beforeLeave()
    this._removeObservers()
    this.removeHandlers()
    this.slotAnimation?.destroy()
    this.homeFirstScrollProgressAnimation?.destroy()
  }

  async leave() {
    await super.leave()
  }

  async afterLeave() {
    await super.afterLeave()
  }

  _set$() {
    super._set$()
    this.$animationSceneBusiness = this.$content.querySelector('[data-animation-scene="home-business"]')
    this.$animationSceneAbout = this.$content.querySelector('[data-animation-scene="home-about"]')
    this.$slideshowWraps = this.$content.querySelectorAll('[data-slideshow-wrap="fade"]') || []
    // this.$animationScene
  }

  addHandlers() {
    super.addHandlers()
    if (Common.resize) {
      Common.resize.addHandler(() => {
        this.onResize()
      }, 'HomeViewControllerResize')
    }
  }

  removeHandlers() {
    super.removeHandlers()
    if (Common.resize) {
      Common.resize.removeHandler('HomeViewControllerResize')
    }
  }

  _addObservers() {
    if (this.$animationSceneBusiness) {
      Common.iom.add(this.$animationSceneBusiness, () => {
        if (!this.isInViwAnimationSceneBusiness) {
          this.isInViwAnimationSceneBusiness = true
          if (this.animationSceneBusiness) {
            this.animationSceneBusiness.enterAnimation()
          }
        }
      })
    }
  }

  _removeObservers() {
    if (this.$animationSceneBusiness) {
      Common.iom.remove(this.$animationSceneBusiness)
      // this.isInViwAnimationSceneBusiness = false
    }
  }

  _setAnimationScenes() {
    if (this.$animationSceneBusiness) {
      this.animationSceneBusiness = new LottieAnimation({
        $target: this.$animationSceneBusiness,
        animationOption: {
          renderer: 'canvas',
          loop: false,
          autoplay: false,
        },
      })
      this.animationSceneBusiness.init()
    }

    if (this.$animationSceneAbout) {
      this.animationSceneAbout = new LottieAnimation({
        $target: this.$animationSceneAbout,
        animationOption: {
          renderer: 'canvas',
          loop: true,
          autoplay: true,
        },
      })
      this.animationSceneAbout.init()
    }
  }

  onResize() {
    super.onResize()
  }
}